import React from "react";
import { UseFormRegister } from "react-hook-form";

export default function InputText({
  placeholder,
  register,
  name,
  value,
  readonly,
  className
}: {
  placeholder?: string;
  register: UseFormRegister<any>;
  name: string;
  readonly?: boolean;
    value?: string;
    className: string;
}) {
  return (
    <>
      <input
        type="text"
        // name={name}
        placeholder={placeholder}
        // className="text-lg font-bold border-b border-[#D7D7D7] w-full py-3 mb-5"
        {...register(name)}
        value={value}
        autoComplete="new"
        readOnly={readonly}
        className={className}
      />
    </>
  );
}
